import { format } from "date-fns";

let TZ = "UTC";
export const setChurchTz = (tz) => { TZ = tz || "UTC"; };

const ymd = (d) => new Intl.DateTimeFormat("en-CA", { timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit" }).format(d);
export const churchToday = () => ymd(new Date());
export const churchHour = () => Number(new Intl.DateTimeFormat("en-US", { timeZone: TZ, hour: "numeric", hourCycle: "h23" }).format(new Date()));
export const addDaysISO = (iso, n) => { const d = new Date(`${iso}T12:00:00Z`); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); };
export const isoToPickerDate = (iso) => new Date(`${iso}T12:00:00`);
export const fmtInChurch = (iso, opts) => new Date(iso).toLocaleString("en-US", { timeZone: TZ, ...opts });
const dayNum = (iso) => Date.UTC(+iso.slice(0, 4), +iso.slice(5, 7) - 1, +iso.slice(8, 10)) / 864e5;

const METHOD = { phone: "Phone call", text: "Text", visit: "Visit", in_person: "In person", email: "Email" };
export const methodLabel = (m) => METHOD[m] || m;

export const ago = (iso) => {
  const d = dayNum(churchToday()) - dayNum(ymd(new Date(iso)));
  return d <= 0 ? "today" : d === 1 ? "yesterday" : `${d} days ago`;
};

export const lastText = (lc) => (lc ? `Last connected: ${methodLabel(lc.method)}, ${ago(lc.at)}` : "No care connection recorded yet");

export const dayLabel = (iso) => format(isoToPickerDate(iso), "EEE, MMM d");

export const dueText = (item) => {
  if (item.kind === "follow_up") {
    if (item.overdue_days > 0) return `${item.reason} · was due ${item.overdue_days === 1 ? "yesterday" : `${item.overdue_days} days ago`}`;
    return `${item.reason} · due today`;
  }
  const src = item.rhythm.kind === "active_care" ? "active care rhythm" : item.rhythm.kind === "group" ? `${item.rhythm.group} rhythm` : "care rhythm";
  return item.overdue_days > 0 ? `Outside the ${item.rhythm.days}-day ${src} by ${item.overdue_days} ${item.overdue_days === 1 ? "day" : "days"}` : `Ready for a check-in · ${item.rhythm.days}-day ${src}`;
};
